import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { api } from "server-api";
import PageWrapper from "components/page/PageWrapper";
import TViewer from 'components/editor/TViewer';

import bg from 'assets/images/banner/banner03.jpg';

export default function ProjectViewer(){
  const {t} = useTranslation();
  const id = useParams().id ?? '0';

  const [post, setPost] = useState(null);

  useEffect(()=>{
    const getPost = async(id)=>{
      const response = await api.get(`/posts/${id}`);
      setPost(response.data);
    }
    getPost(id);
  },[id]);

  const parentMenuName= t('menu.sub-references');
  const menuName=t('menu.sub-viewer');
  const path=[
    {url:'/projects', name:t('menu.main-about')}, 
    {url:'/projects', name:parentMenuName},
    {url:`/projects/${id}`, name:post?.title?? id},
  ];
  const title = t('references.banner.title')
  const comment = t('references.banner.comment')

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex justify-center">
        <div className="flex flex-col lg:w-[1200px]">
          {post!=null ?
            <TViewer {...post}
              editUrl="/projects/editor"/>
            :null
          }
        </div>
      </div>
    </PageWrapper>
  );
}